import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { INgsiEntityIdAttrs } from '../../shared/interfaces/ngsi/entity.interface';

@Injectable({
  providedIn: 'root'
})
export class ThrusterService {
  private readonly selectedEntityId: Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>> =
      new Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined >>();

  private readonly selectedThrusterId: Map<string, BehaviorSubject<number | undefined>> =
      new Map<string, BehaviorSubject<number | undefined >>();

  // Gets the observable for a specific widgetId
  getThrusterEntity$(widgetId: string): Observable<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined> {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    return this.selectedEntityId.get(widgetId)!.asObservable();
  }

  // Sets a new thruster entity for a specific widgetId
  setThrusterEntity(widgetId: string, entityId: Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined): void {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    this.selectedEntityId.get(widgetId)!.next(entityId);
  }

  // Clean up
  removeThrusterEntity(widgetId: string): void {
    const subject = this.selectedEntityId.get(widgetId);
    if (subject) {
      subject.complete(); // Clean up subscribers
      this.selectedEntityId.delete(widgetId);
    }
  }

  // Gets the observable for a specific widgetId
  getThrusterId$(widgetId: string): Observable<number | undefined> {
    if (!this.selectedThrusterId.has(widgetId)) {
      this.selectedThrusterId.set(widgetId, new BehaviorSubject<number | undefined>(undefined));
    }

    return this.selectedThrusterId.get(widgetId)!.asObservable();
  }

  // Sets a new thrusterId for a specific widgetId
  setThrusterId(widgetId: string, thrusterId: number | undefined): void {
    if (!this.selectedThrusterId.has(widgetId)) {
      this.selectedThrusterId.set(widgetId, new BehaviorSubject<number | undefined>(undefined));
    }

    this.selectedThrusterId.get(widgetId)!.next(thrusterId);
  }

  // Clean up
  removeThrusterId(widgetId: string): void {
    const subject = this.selectedThrusterId.get(widgetId);
    if (subject) {
      subject.complete(); // Clean up subscribers
      this.selectedThrusterId.delete(widgetId);
    }
  }
}
